import { AnimatePresence, motion, useReducedMotion } from 'motion/react';
import React from 'react';
import { useSetRecoilState } from 'recoil';

import { useEventCallback } from '@gitbook/util-react-hooks';

import { onboardingSkippedAtom } from '../../../../state';
import { useHomeContext } from '../../HomeContext';
import { useOnboardingRules } from '../../hooks/useOnboardingRules';
import { JumpInSection } from './JumpInSection';

export const Onboarding = React.lazy(() => import('./Onboarding'));

export function ActivitySection() {
    const { organization } = useHomeContext();
    const shouldReduceMotion = useReducedMotion();
    const setOnboardingSkipped = useSetRecoilState(onboardingSkippedAtom);
    const skipOnboarding = useEventCallback(() => {
        setOnboardingSkipped(true);
    });

    const { isOnboarding } = useOnboardingRules({ organization });
    return (
        <section className="my-0 flex flex-col gap-4 pt-6 md:gap-6 lg:gap-0">
            <AnimatePresence>
                {isOnboarding ? (
                    <motion.div
                        variants={{
                            exit: { opacity: 0 },
                            animate: {
                                opacity: 1,
                                transition: {
                                    opacity: { delay: 0.1, duration: shouldReduceMotion ? 0 : 0.1 },
                                },
                            },
                        }}
                        initial="exit"
                        animate="animate"
                        exit="exit"
                    >
                        <Onboarding onSkipOnboarding={skipOnboarding} />
                    </motion.div>
                ) : (
                    <motion.div
                        variants={{
                            exit: { opacity: 0 },
                            animate: {
                                opacity: 1,
                                transition: {
                                    opacity: { delay: 0.1, duration: shouldReduceMotion ? 0 : 0.1 },
                                },
                            },
                        }}
                        initial="exit"
                        animate="animate"
                        exit="exit"
                    >
                        <JumpInSection organization={organization} />
                    </motion.div>
                )}
            </AnimatePresence>
        </section>
    );
}
